
import BillPayMultiCard from './billPayMultiCard';
import classes from "./billPayMultiContainer.scss";
import CustomAnchorTag from '../../../../Common/CommonComponents/CustomAnchorTag/customAnchorTag';
import SearchBox from "../../../../Common/SearchBox/searchBox";
import PaperlessBillingTurnonPopup from "../../../../Centralized/AccountPreferences/PB/Presentational/PaperlessBillingTurnonPopup";
import PaperlessBillingTurnoffPopup from '../../../../Centralized/AccountPreferences/PB/Presentational/PaperlessBillingTurnoffPopup';
import ViewEditPaperlessBilling from '../../../../Centralized/AccountPreferences/PB/Presentational/ViewEditPaperlessBilling';
import ConfirmationPopup from '../../../../Centralized/AccountPreferences/PB/Presentational/ConfirmationPopup';
import DownloadBillLoader from "../../../../Common/CommonComponents/DownloadBillSpinner/downloadBillLoader";
import BillPayMultiHelper from "./billPayMultiHelper";
import SortDropDown from '../../../../Common/CommonComponents/SortDropDown/sortDropDown';
import NoDataBlock from '../../../../Common/NoDataBlock/noDataBlock';
import PaginationComponent from "../../../../Dashboard/Common/Pagination/pagination";
import SearchInfoPopup from '../../../../Dashboard/Common/searchInfoPopup';
import PaperlessBillingDeEnrollConfirmPopup from '../../../../Centralized/AccountPreferences/PB/Presentational/PaperlessBillingDeEnrollConfirmPopup';
export default class BillAndPayContainer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],currentPage: 1,noOfAccounts:this.props.noOfAccounts,
            accountRange: { firstRecord: null, lastRecord: null },
            searchBarInfo: { searchText: '', isError: '' },
            settingsTableData: this.props.sessionCA === null ? this.props.settingsTableValues.customerAccountListData : [],
            settingsTableDataSelected: {}, preferenceData: '',errorCode: '', paperlessBillingData: { primaryEmail: '' }, preferenceDataAuth: '',
            paperlessBilling: { pbEnroll: false, viewEditPopUp: false, emails: '',enrolledCount:null,enrollResponse:null,isPbEnrollConfirmTest:false},
            showSpinner: false, deEnrollConfirmPopup: false, yesCancelDeEnroll:"", searchMode:false, searchInfo:false, ebillpaprCount : "", ebillpaprRecord:{record:[]}, ebillpaprSold:{record:[]}, ebillpaprAuth:{record:[]},
        };
        this.sortDirection = app.appUtil.getAppConstants().SORT_CRITERIA.ACCNUM_ASC;
        this.ACCOUNTS_PER_PAGE = 10,
        this.customerData = {};
        this.multiPaprRec={};
        this.AccType="Single";
        this.initialPositionValue = window.getComputedStyle(document.body).position;
        this.billPayIdentifier=app.appService.getSessionstorage('billPayIdentifier');
        this.submitClick = BillPayMultiHelper.submitClick.bind(this);
        this.submitDeenrollClick= BillPayMultiHelper.submitDeenrollClick.bind(this);
        this.getCustomerData = BillPayMultiHelper.getCustomerData.bind(this);
        //------ebill---getPaprEnrolledEmail 
        this.getPaprEnrolledEmail = BillPayMultiHelper.getPaprEnrolledEmail.bind(this), this.getFormattedPreferenceData = BillPayMultiHelper.getFormattedPreferenceData.bind(this);
        this.checkLoginEmail=BillPayMultiHelper.checkLoginEmail.bind(this);
        this.handleServiceError=BillPayMultiHelper.handleServiceError.bind(this), this.closeViewEditConfirmPopup=BillPayMultiHelper.closeViewEditConfirmPopup.bind(this);
        this.overlayFocusController=BillPayMultiHelper.overlayFocusController.bind(this);
        this.imageInfo = drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/dss_infio.svg';
        this.searchOrRefreshSetData=BillPayMultiHelper.searchOrRefreshSetData.bind(this), this.getSearchCALabelText = BillPayMultiHelper.getSearchCALabelText.bind(this);}
    componentDidMount(){
        if(this.props.sessionCA!==null){
            this.setState({showSpinner:true, searchBarInfo:{searchText: this.props.sessionCA}});
            this.getSearchedRows({'contractAccountNumber': this.props.sessionCA}, true); }
        this.billPayIdentifier && this.billPayIdentifier.pageReload ? this.onPageChange(this.billPayIdentifier.currentPage, 'nextPage') : null;
        app.appService.setSessionstorage('billPayIdentifier',{'pageReload':false,'currentPage':1}); }
    getPagination() {
        let totalAccounts = this.state.noOfAccounts;
        let totalPageCount = Math.ceil(totalAccounts / this.ACCOUNTS_PER_PAGE);
        let billPayIdentifier = app.appService.getSessionstorage('billPayIdentifier');
        let currentPage = billPayIdentifier && billPayIdentifier.pageReload ? billPayIdentifier.currentPage : this.state.currentPage;
        return <PaginationComponent currentPage={currentPage} pageFlag={this.state.pageFlag} pageCount={totalPageCount} onPageChange={this.onPageChange} />;}
    onPageChange = (value,pageFlag) => {
        app.appService.setSessionstorage('billPayIdentifier',{'pageReload':false,'currentPage':value});
        let reqObj = {};
        document.querySelector('#searchBoxScroll').scrollIntoView();
        let billPayIdentifier=app.appService.getSessionstorage('billPayIdentifier');
        let currentPage = value;
        if (billPayIdentifier.pageReload) { 
            currentPage = billPayIdentifier.currentPage; 
        }
        this.setState({ currentPage: currentPage, pageFlag: pageFlag });
        //pagination logic
        let limit = this.ACCOUNTS_PER_PAGE;
        let offset = this.ACCOUNTS_PER_PAGE * (currentPage - 1);
        if (this.sortDirection === "DESC") {
            offset = this.state.noOfAccounts - ((currentPage) * this.ACCOUNTS_PER_PAGE);
            if (offset < 0) {
                limit = this.ACCOUNTS_PER_PAGE - Math.abs(offset);
                offset = 0;}}
        reqObj.offset = offset;
        reqObj.sortDirection = this.sortDirection;
        reqObj.limit = limit;
        this.fetchData(reqObj);  }
    sortAccount = (value) => {
        let reqParams = {};
        let offset = (this.state.currentPage - 1) * this.ACCOUNTS_PER_PAGE;
        this.sortDirection = value ;
        let limit = this.ACCOUNTS_PER_PAGE;
        let totalAccounts = this.state.noOfAccounts;
        if (value === "DESC") {
            offset = totalAccounts - ((this.state.currentPage) * this.ACCOUNTS_PER_PAGE);
            if (offset < 0) {
                limit = this.ACCOUNTS_PER_PAGE - Math.abs(offset);
                offset = 0;
            } }
        reqParams.sortDirection = this.sortDirection;
        reqParams.offset = offset;
        reqParams.limit = limit;
        this.fetchData(reqParams); }

    getBillingContent = () => {
        let maskedEmail = !_.isEmpty(this.state.enrolledPbEmail) ? this.state.enrolledPbEmail.replace(/^(...)(.*)(@.*)$/, (_, a, b, c) => a + '****' + c) : null;
        return this.state.settingsTableData.map((accountDetails, index) => {
            let eligibilityData = accountDetails.eligibilityData;
            let association = accountDetails.association;
            let autoPay = {}, pBilling = {};
            if (eligibilityData === null) {
                autoPay = 'NoData', pBilling = 'NoData';
            } else {
                eligibilityData.map((eachData) => {
                    if (eachData.programDescription === "DPP") {
                        autoPay.isDpIneligible = eachData.identifier === "DpIneligible";
                        autoPay.isDpEnrolled = eachData.identifier === "DpDeEnroll";
                        autoPay.associatedDpBank = eachData.identifier === "DpDeEnroll" ? association.bankName : null;
                    } else {
                        pBilling.isObIneligible = eachData.identifier === "ObIneligible";
                        pBilling.isObEnrolled = eachData.identifier === "ObDeEnroll";
                        pBilling.email = eachData.preferredEmailId;
                    }
                });}
            return (
                <BillPayMultiCard ineligibleMessage={this.props.ineligibleMessage} settingsTableData={accountDetails} onDpToggle={this.props.onDpToggle} openPbDeEnroll={this.openPbDeEnroll} openPbEnroll={this.openPbEnroll} openViewEdit={this.openViewEdit} fetchData={this.fetchData} autoPay={autoPay} pBilling={pBilling} currentPage={this.state.currentPage} sortDirection={this.sortDirection} />
            ); });}

    handleSearchEvents(e, triggerEvent) {
        let events = {
            alertDismissed:false, alertInteracted:false, manageAccount:false, makePayment:false, autoPayEnroll:false, paperlessEnroll:false, viewBill:false, viewUsage:false, custom:false, autopayCancel:false, paperlessCancel:false, sdpEnroll:false, sepEnroll:false, savingsPlan:false, paymentArrangement:false,componentClick:true,componentName:'multi_grid', search:true
        };
        app.analyticsService.addPageLevelData('eventCapturing', events); 
        app.logger.getLogger().info('entering handleSearchEvents function');
        switch (triggerEvent) {
            case 'onChange': {
                const reg = new RegExp(/^[0-9]+$/);
                if(reg.test(e.target.value) || e.target.value==="")
                    {this.setState({ searchBarInfo: { searchText: e.target.value } });
                }
                break;}
            case 'onClear': {
                this.setState({ searchBarInfo: { searchText: '', isError: false } }, () => {
                    this.setState({ searchMode: false, currentPage: 1, pageFlag: 'nextPage' });
                    this.resetSortDropDown = true;
                    this.getSearchedRows({}, false);
                });
                break;}
            case 'onSearch': {
                e.preventDefault();
                if(this.state.searchBarInfo.searchText===''){
                    this.setState({searchBarInfo: { searchText: '', isError: false }});
                    if(( this.state.searchMode) || this.state.errorCode!==""){
                        this.setState({ searchMode: false, currentPage: 1, pageFlag: 'nextPage' });
                        this.resetSortDropDown = true;
                        this.getSearchedRows({}, false);}
                }else if (this.state.searchBarInfo.searchText.length!==12 || (this.state.searchBarInfo.searchText.charAt(0)==="7"?false:this.state.searchBarInfo.searchText.charAt(0)==="6"?false:true)) {
                    this.setState({ searchBarInfo: {...this.state.searchBarInfo, isError:true}});
                }else if(isNaN(this.state.searchBarInfo.searchText)){
                    this.setState({ searchBarInfo: { searchText: this.state.searchBarInfo.searchText, isError: true } });
                }else {
                    this.getSearchedRows({ 'contractAccountNumber': this.state.searchBarInfo.searchText }, true);
                    this.setState({ searchBarInfo: searchBarInfo });
                }
                break;
            }} }
    fetchData = (requestObj,searchOrRefreshFlag) => {
        this.setState({ showSpinner: true });
        app.settingsService.getBillingAccountsDetails(requestObj).then(
            response => {
                this.searchOrRefreshSetData(response,searchOrRefreshFlag);
                if(this.props.sessionCA!==null){
                    this.props.clearSessionResult();}
            },
            error => {
                this.setState({ errorCode: error.errorCode, showSpinner: false });
                if(this.props.sessionCA!==null){
                    this.props.clearSessionResult();}
            });}
    handleCloseErrorBox=()=>{
        this.setState({ searchBarInfo: {...this.state.searchBarInfo, isError:false}});}
    getSearchedRows = (reqParams,searchFlag) => {
        app.appService.setSessionstorage('billPayIdentifier',{'pageReload':false,'currentPage':1});
        reqParams = reqParams || {};
        reqParams.sortDirection = this.sortDirection;
        let requestObj = reqParams;
        this.fetchData(requestObj, searchFlag ? 'search' : null); }

    popupCallback = (d, unselected, selectAllFlag, contractAccountCount) => {
        const updatedState = { ...this.state };
        updatedState.data = d, updatedState.unselected = unselected, updatedState.selectAllflag = selectAllFlag, updatedState.contractAccountCount = contractAccountCount, this.setState(updatedState);}
   
   getAccountData = () => {
        let accountData = {Name: "", contractAccountNumber: "", houseNumber: "", streetAddress: "", supplement:"", city: "", state: "", zipcode: "", obEnrollmentFlag: "", isEligible: "", nextStatementDate: "", bpNumber: "", postBoxNumber:"", };
        accountData.Name = this.state.settingsTableDataSelected.customerAccountName;
        accountData.bpNumber = this.state.settingsTableDataSelected.customerNumber;
        accountData.houseNumber = this.state.settingsTableDataSelected.mailingAddress.houseNumber;
        accountData.state = this.state.settingsTableDataSelected.mailingAddress.region;
        accountData.zipcode = !_.isEmpty(this.state.settingsTableDataSelected.mailingAddress.poPostalCode)?this.state.settingsTableDataSelected.mailingAddress.poPostalCode:this.state.settingsTableDataSelected.mailingAddress.postalCode;
        accountData.postBoxNumber = this.state.settingsTableDataSelected.mailingAddress.poBox;
         accountData.city  =  this.state.settingsTableDataSelected.mailingAddress.city;
        accountData.streetAddress =  this.state.settingsTableDataSelected.mailingAddress.street;
        accountData.supplement = this.state.settingsTableDataSelected.mailingAddress.supplement;
        accountData.contractAccountNumber = this.state.settingsTableDataSelected.contractAccountNumber;
        this.state.settingsTableDataSelected.eligibilityData ? this.state.settingsTableDataSelected.eligibilityData.forEach(element => {
            if (element.programDescription === "OBP") {
                accountData.obEnrollmentFlag = element.enrolledFlag;
                accountData.isEligible = element.eligibilityFlag;}
        }) : null;
        accountData.nextStatementDate = this.state.settingsTableDataSelected.nextStatementDate;
        return accountData;
    }
    getPBEnrollPopUp = () => {
        let accountData = this.getAccountData();
        return <PaperlessBillingTurnonPopup containerCallback={this.popupCallback} data={this.state.data} contractAccountNumber={this.state.settingsTableDataSelected.contractAccountNumber} contractAccountResults={this.state.settingsTableData} accType={this.AccType} accountData={accountData} nextStDate={this.state.settingsTableDataSelected.nextStatementDate} bpNumber={this.state.settingsTableDataSelected.customerNumber} submitClick={this.submitClick} isOpen={this.cancelButtonHandler.bind(this)} primaryEmail={this.state.paperlessBillingData.primaryEmail} isPbEnrollConfirm={this.state.paperlessBilling.isPbEnrollConfirm} currentPage={this.state.currentPage} pbEnrollErrMsg={this.state.paperlessBilling.pbEnrollErrMsg} ebillpaprCount={this.state.ebillpaprCount} />;
    }
    getPBDeEnrollPopUp=()=>{
        let accountData = this.getAccountData();
        return <PaperlessBillingTurnoffPopup accountData={accountData} submitDeenrollClick={this.submitDeenrollClick} isOpen={this.cancelButtonHandlerTurnoffPopup.bind(this)} isPbDeEnrollConfirm={this.state.paperlessBilling.isPbDeEnrollConfirm} ebillpaprCount={this.state.preferenceDataAuth.emailSet.length} />;
    }
    getViewEditPopUp=()=>{
        let accountData=this.getAccountData();
        return <ViewEditPaperlessBilling emails={this.state.paperlessBillingData.emails} loginEmail={app.appService.getUserInfo().email} accountData={accountData} isOpen={this.cancelViewButtonHandlers.bind(this)} primaryEmail={this.state.paperlessBillingData.primaryEmail} enrolledEmail={this.state.paperlessBillingData.enrolledEmail} prefData={this.multiPaprRec} bpNumber={this.state.settingsTableDataSelected.customerNumber} enrolledEmailObj={this.state.paperlessBillingData.enrolledEmail} customerData={this.customerData} preferenceData={this.state.preferenceData} preferenceDataAuth={this.state.preferenceDataAuth} ebillpaprRecord={this.state.ebillpaprRecord} closePopUp={this.closeViewEditConfirmPopup.bind(this)} />;
    }
    getPBConfirmPopUp = () => {
        let accountData=this.getAccountData();
        return <ConfirmationPopup nextStDate={this.state.settingsTableDataSelected.nextStatementDate} enrolledCount={this.state.paperlessBilling.enrolledCount} primaryEmail={this.state.paperlessBillingData.primaryEmail} accType={this.AccType} accountData={accountData} isOpen={this.cancelButtonHandler.bind(this)} isConfOpen={this.cancelConfirmationButtonHandlers.bind(this)} />;
      }
      getdeEnrollConfirmPopup = () => {
        let accountData = this.getAccountData();
        return <PaperlessBillingDeEnrollConfirmPopup prefenceDataCount={null} ebillpaprCount={this.state.preferenceDataAuth.emailSet.length} accountData={accountData} closePopup={this.closeButtonHandlerDeEnrollPopup.bind(this)} yesCancelDeEnroll={this.state.yesCancelDeEnroll} />;
      }
    cancelViewButtonHandlers() {
        this.setState({ paperlessBilling: { viewEditPopUp: false },paperlessBillingData:{}, deEnrollConfirmPopup: true, yesCancelDeEnroll: false }, () => { });
    }
    cancelButtonHandler() {
        this.setState({ paperlessBilling: { pbEnroll: false }, data: 1 });
    }
    cancelButtonHandlerTurnoffPopup() {
        this.setState({ paperlessBilling: {pbDeEnroll: false }});
        this.setState({ deEnrollConfirmPopup: true }, () => { });
        this.setState({ yesCancelDeEnroll: false }, () => { });
      }
    closeButtonHandlerDeEnrollPopup(){
        this.setState({ deEnrollConfirmPopup: false });
        window.location.reload();
      }
    cancelConfirmationButtonHandlers() {
        let pbParam = {...this.state.paperlessBilling};
        pbParam.isPbEnrollConfirmTest = false;
        pbParam.data = 1;
        this.setState({paperlessBilling:pbParam});
    }
    openPbEnroll = (settingsTableDataSelected) => {
        this.setState({ settingsTableDataSelected: settingsTableDataSelected });
        this.getCustomerData(settingsTableDataSelected.contractAccountNumber, settingsTableDataSelected.customerNumber,'enroll');
    }
    openPbDeEnroll = (settingsTableDataSelected) => {
        this.setState({ settingsTableDataSelected: settingsTableDataSelected });
        this.getCustomerData(settingsTableDataSelected.contractAccountNumber, settingsTableDataSelected.customerNumber,'deEnroll');
        //--------Ebill----get email for deEnroll----
        this.getPaprEnrolledEmail(settingsTableDataSelected.contractAccountNumber, settingsTableDataSelected.customerNumber,'deEnroll');
    }
    openViewEdit=(settingsTableDataSelected)=>{
        this.setState({settingsTableDataSelected:settingsTableDataSelected});
        this.getCustomerData(settingsTableDataSelected.contractAccountNumber, settingsTableDataSelected.customerNumber,'viewEdit');
        this.getPaprEnrolledEmail(settingsTableDataSelected.contractAccountNumber, settingsTableDataSelected.customerNumber,'viewEdit');
    }
    managePayment=()=>{
        let events = {
            alertDismissed:false, alertInteracted:false, manageAccount:true, makePayment:false, autoPayEnroll:false, paperlessEnroll:false, viewBill:false, viewUsage:false, custom:false, autopayCancel:false, paperlessCancel:false, sdpEnroll:false, sepEnroll:false, savingsPlan:false, paymentArrangement:false,componentClick:true,componentName:'multi_grid'
        };
        app.analyticsService.addPageLevelData('eventCapturing', events); 
        window.aUtils ? window.aUtils.sendAAEvent("link", `settings|billing_payments|none|multi_grid|page|Manage_Payment_Methods`) : null;
        app.appUtil.navigateTo(app.appUtil.getAppRoutes().BILLING.MANAGE_PAYMENT);
    }
    getSortSection =()=>{
        let horizontalRuling=<span className={classes.horizontalRuling} />;
        return (
            <div className={classes.sortSectionBlock}>
                {horizontalRuling}<SortDropDown sortAccount={this.sortAccount.bind(this)} />
            </div>
        );}
    handleSearchInfo=()=>{this.setState({searchInfo:!this.state.searchInfo});}
    pbdeEnrollConfirmPopup = () =>{ return this.state.deEnrollConfirmPopup ? this.getdeEnrollConfirmPopup() : null; }
    render() {
        this.overlayFocusController();
        const linkName = 'Manage Payment Methods', accountSearchType = 'contract ', authError = <div className={this.state.searchBarInfo.isError ? classes.sceErrorMargin : null}><NoDataBlock accountSearchType={accountSearchType} content={this.props.content} isSearchTextError={this.state.searchBarInfo.isError} isCA /></div>,horizontalRuling=<span className={classes.horizontalRuling} />;
        const showSpinner = this.state.showSpinner ? <DownloadBillLoader /> : null;
        let billingContent = this.state.settingsTableData!==undefined?this.getBillingContent():null, pagination = (this.state.noOfAccounts>10 && !this.state.searchMode && this.state.errorCode==="")?this.getPagination():null;
        let mainContent = this.state.errorCode === '' ? billingContent :authError,searchInfoPopup = this.state.searchInfo?<SearchInfoPopup handleSearchInfo={this.handleSearchInfo.bind(this)} content={this.props.content} caContent />:null;
        let pbOnPopUp = this.state.paperlessBilling.pbEnroll ? this.getPBEnrollPopUp() : null, pbOffPopUp=this.state.paperlessBilling.pbDeEnroll ? this.getPBDeEnrollPopUp() : null,viewEdit = this.state.paperlessBilling.viewEditPopUp ? this.getViewEditPopUp() : null,confirmPopUp = this.state.paperlessBilling.isPbEnrollConfirmTest?this.getPBConfirmPopUp():null;
        let pageStartCount = (this.state.currentPage - 1) * this.ACCOUNTS_PER_PAGE + 1,pageEndCount = (this.state.currentPage * this.ACCOUNTS_PER_PAGE) < this.state.noOfAccounts ? (this.state.currentPage * this.ACCOUNTS_PER_PAGE) : this.state.noOfAccounts;
        let accountRange = this.state.searchMode ? <span className={classes.sceTableHeader}>1 Matching Result Found</span> : <span className={classes.sceTableHeader}>{`${pageStartCount}-${pageEndCount} of ${this.state.noOfAccounts} Customer Accounts`}</span>;
        let acountRangeSection = this.state.errorCode !== '' ? null : <div className={[classes.sceAccountLinkContainer, this.state.searchBarInfo.isError ? classes.sceAccounLinkContainerMarginTop : ""].join(" ")}>{accountRange}<div className={classes.sceDropDownContainer}><span className={classes.sceManageLink}><CustomAnchorTag linkName={linkName} className={classes.sceManagePaymentLink} isUnderline onClick={this.managePayment} />{this.state.searchMode?null:this.getSortSection()}</span></div></div>;
        let searchLabelText = this.getSearchCALabelText(this.props.content.dss_search_label);
        let pbdeEnrollConfirmPopup = this.pbdeEnrollConfirmPopup();
        return (
            <div className={classes.sceBillPayContainer} id='searchBoxScroll'>
                {showSpinner}
                <div className={classes.sceBillingSearchDiv}>
                    <SearchBox searchBarInfo={this.state.searchBarInfo} handleCloseErrorBox={this.handleCloseErrorBox.bind(this)} handleSearchEvents={this.handleSearchEvents.bind(this)} searchLabel={searchLabelText.labelContent} placeholder={searchLabelText.placeholder} isCA content={this.props.content} />
                </div>
                {acountRangeSection}
                {mainContent}
                {pagination}
                {pbOnPopUp}
                {pbOffPopUp}
                {viewEdit}
                {confirmPopUp}{pbdeEnrollConfirmPopup}
            </div>);}
}
